export default class ServiceJobCategoryModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970,0,1);
			this.name = data.name ?? '';
			this.description = data.description ?? null;
			this.costPerHour = data.costPerHour ?? 0;
			
		}
	}

	id = 0;	
	date = new Date(1970,0,1);
	name = '';
	description: string | null = null;
	costPerHour = 0;
}